const LOCAL_STORAGE_COMPARE_KEY = 'shopify-compare';
const LOCAL_COMPARE_STORAGE_DELIMITER = ',';
const BUTTON_COMPARE_ACTIVE_CLASS = 'compare-active'; 
const GRID_COMPARE_LOADED_CLASS = 'loaded';

const compareSelectors = {
  button: '[button-compare]',
  grid: '[grid-compare]',
  productCard: '.product-card-compare',
};

document.addEventListener('DOMContentLoaded', () => {
  initButtonsCompare();
  initGridCompare();
});

document.addEventListener('shopify-compare:updated', (event) => {
  initGridCompare();
});

const fetchCompareProductCardHTML = (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=compare-no-layout`;
  return fetch(productTileTemplateUrl)
  .then((res) => res.text())
  .then((res) => {
    const text = res;
    const parser = new DOMParser();
    const htmlDocument = parser.parseFromString(text, 'text/html');
    const productCard = htmlDocument.documentElement.querySelector(compareSelectors.productCard);
    return productCard.outerHTML;
  })
  .catch((err) => console.error(`[Shopify Compare] Failed to load content for handle: ${handle}`, err));
};

const setupGridCompare = async (grid) => {
  const compare = getCompare();
  const requests = compare.map(fetchCompareProductCardHTML);
  const responses = await Promise.all(requests);
  const compareProductCards = responses.join('');
  grid.innerHTML = compareProductCards;
  grid.classList.add(GRID_COMPARE_LOADED_CLASS);
  initButtonsCompare();

  const event = new CustomEvent('shopify-compare:init-product-grid', {
    detail: { compare: compare }
  });
  document.dispatchEvent(event);
};

const setupCompareButtons = (buttons) => {
  buttons.forEach((button) => {
    const productHandle = button.dataset.productHandle || false;
    if (!productHandle) return console.error('[Shopify Compare] Missing `data-product-handle` attribute. Failed to update the compare.');
    if (compareContains(productHandle)) button.classList.add(BUTTON_COMPARE_ACTIVE_CLASS);
    button.addEventListener('click', () => {
      updateCompare(productHandle);
      button.classList.toggle(BUTTON_COMPARE_ACTIVE_CLASS);
      button.classList.add('adding-compare');
      setTimeout(() => {
        button.classList.remove('adding-compare'); 
      }, 1000);
    });
  });
};

const initGridCompare = () => {
  const grid = document.querySelector(compareSelectors.grid) || false;
  if (grid) setupGridCompare(grid);
};

const initButtonsCompare = () => {
  const buttons = document.querySelectorAll(compareSelectors.button) || [];
  if (buttons.length) setupCompareButtons(buttons);
  else return;
  const event = new CustomEvent('shopify-compare:init-buttons', {
    detail: { compare: getCompare() }
  });
  document.dispatchEvent(event);
};

const getCompare = () => {
  const compare = localStorage.getItem(LOCAL_STORAGE_COMPARE_KEY) || false;
  if (compare) return compare.split(LOCAL_COMPARE_STORAGE_DELIMITER);
  return [];
};

const setCompare = (array) => {
  const compare = array.join(LOCAL_COMPARE_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_COMPARE_KEY, compare);
  else localStorage.removeItem(LOCAL_STORAGE_COMPARE_KEY);

  const event = new CustomEvent('shopify-compare:updated', {
    detail: { compare: array }
  });   
  updateCompareCount();
  document.dispatchEvent(event);

  return compare;
};

const updateCompare = (handle) => {
  const compare = getCompare();
  const indexInCompare = compare.indexOf(handle);
  if (indexInCompare === -1) compare.push(handle);
  else compare.splice(indexInCompare, 1);
  return setCompare(compare);
};

const compareContains = (handle) => {
  const compare = getCompare();
  return compare.includes(handle);
};

const resetCompare = () => {
  return setCompare([]);
};


function compareToaster() {
  const progressBar = document.getElementById('compareToastProgress');

  function showToast(event) {
    if (event.currentTarget.classList.contains('compare-active')) { 
      return;
    }

    const toast = document.getElementById('compareToast');
    toast.style.display = 'block';
    progressBar.style.width = '0%';

    let progress = 0;
    const duration = 5000;

    function updateProgressBar() {
      if (progress < 100) {
        progress += (100 / duration) * 1000 / 60;
        progressBar.style.width = `${progress}%`;
        requestAnimationFrame(updateProgressBar);
      } else {
        toast.style.display = 'none';
      }
    }
    requestAnimationFrame(updateProgressBar);
  }

  this.initToaster = function () {
    const toggleButtons = document.querySelectorAll('.btn_compare:not(.compare-active)');
    toggleButtons.forEach(function (button) {
      button.addEventListener("click", showToast);
    });
  };
}
const compare_local_toast = new compareToaster();
compare_local_toast.initToaster();

const updateCompareCount = () => {
    const compare = getCompare();
  
    const CompareCountElements = document.querySelectorAll('[data-header-compare-count], [data-account-compare-count]');
    CompareCountElements.forEach((element) => {
      element.setAttribute('data-header-compare-count', compare.length);
      element.textContent = compare.length;
    });
  
    const CompareTextElement = document.querySelector('.compare-text');
    if (CompareTextElement) {
        CompareTextElement.style.display = compare.length === 0 ? 'block' : 'none';
    }
};
  
  document.addEventListener('DOMContentLoaded', function() {
    updateCompareCount();
  });